<template>
  <main>
    <div class="l-main-content__inner">

      <div class="c-page-header">
        <h1 class="c-page-header-title">学習進捗表</h1>
      </div>

      <dl class="p-learning-filtering">
          <!-- 年度 -->
          <select-single
            v-if="academicYearsClassrooms"
            title="年度"
            :options="academicYearsClassrooms.academicSessionIds"
            v-model:selected="academicSessionId"
            @change="changeAcademicSessionId"
            :init-blank="false"
          ></select-single>

          <!-- 学年 -->
          <select-single
            v-if="academicYearsClassrooms"
            title="学年"
            ref="academicYearsSelector"
            :options="academicYearsBelongCurrentAcademicSessionId"
            v-model:selected="academicYear"
            @change="changeAcademicYear"
          ></select-single>

          <!-- 学級 -->
          <select-single
            v-if="academicYearsClassrooms"
            title="学級"
            :options="classroomsBelongCurrentAcademicYear"
            v-model:selected="classroom"
            @change="changeClassroom"
          ></select-single>
        </dl>

      <section>
        <learning-progress-subject-tabs
          :subjects="subjects"
          :subject="subject"
          @click="clickSubject"
        ></learning-progress-subject-tabs>

        <!-- 教材 -->
        <div class="c-parts-box -white -learning">
          <div class="p-learning-select">
            <div class="p-learning-select__head">
              <div class="title">学習進捗を確認したい項目を選び、「検索する」ボタンをおしてください。</div>
            </div>
          </div>
          <ul
            ref="refProgressSelectsList"
            class="p-learning-select__list"
          >
            <!-- 教材 -->
            <li class="p-learning-select__list__item">
              <div class="subList__wrapper">
                <ul
                  v-if="works"
                  class="subList on"
                >
                  <li
                    v-for="work in works"
                    :key="work.id"
                    class="subList__item"
                  >
                    <label class="radio">
                      <input
                        v-model="workId"
                        :value="work.id"
                        :id="`work-${work.id}`"
                        type="radio"
                        name="works"
                        @change="changeWork($event)"
                      >
                      <span class="radio__text">
                        <plain-text-view
                          :markdown-text="work.name"
                        ></plain-text-view>
                      </span>
                    </label>
                  </li>
                </ul>
              </div>
            </li>
            <!-- 親項目 -->
            <li
              v-if="hasTitledParts"
              class="p-learning-select__list__item"
            >
              <div class="subList__wrapper">
                <ul
                  v-if="parts"
                  class="subList on"
                >
                  <li
                    v-for="part in parts"
                    :key="part.id"
                    class="subList__item"
                  >
                    <label class="radio">
                      <input
                        v-model="partId"
                        :value="part.id"
                        :id="`part-${part.id}`"
                        type="radio"
                        name="parts"
                        @change="changePart($event)"
                      >
                      <span class="radio__text">
                        <plain-text-view
                          :markdown-text="part.title"
                          :prefix="part.prefix"
                        ></plain-text-view>
                      </span>
                    </label>
                  </li>
                </ul>
              </div>
            </li>
            <!-- 子項目 -->
            <li class="p-learning-select__list__item">
              <div class="subList__wrapper">
                <ul
                  v-if="chapters"
                  class="subList on"
                >
                  <li
                    v-for="chapter in chapters"
                    :key="chapter.id"
                    class="subList__item"
                  >
                    <label class="radio">
                      <input
                        v-model="chapterId"
                        :value="chapter.id"
                        :id="`chapter-${chapter.id}`"
                        type="radio"
                        name="chapters"
                        @change="changeChapter($event)"
                      >
                      <span class="radio__text">
                        <plain-text-view
                          :markdown-text="chapter.title"
                          :prefix="chapter.prefix"
                        ></plain-text-view>
                      </span>
                    </label>
                  </li>
                </ul>
              </div>
            </li>
            <!-- 孫項目 -->
            <li class="p-learning-select__list__item">
                <div class="subList__wrapper">
                  <ul
                    v-if="sections"
                    class="subList on"
                  >
                    <li
                      v-for="section in sections"
                      :key="section.id"
                      class="subList__item"
                    >
                      <label class="radio">
                        <input
                          v-model="sectionId"
                          :value="section.id"
                          :id="`section-${section.id}`"
                          type="radio"
                          name="sections"
                          @change="changeSection($event)"
                        >
                        <span class="radio__text">
                          <plain-text-view
                            :markdown-text="section.title"
                            :prefix="section.prefix"
                          ></plain-text-view>
                        </span>
                      </label>
                    </li>
                  </ul>
                </div>
            </li>
            <!-- 出題単位 -->
            <li class="p-learning-select__list__item">
                <div class="subList__wrapper">
                  <ul
                    v-if="questionSets"
                    class="subList on"
                  >
                    <li
                      v-for="question_set in questionSets"
                      :key="question_set.id"
                      class="subList__item"
                    >
                      <label class="radio">
                        <input
                          v-model="questionSetId"
                          :value="question_set.id"
                          :id="`question_set-${question_set.id}`"
                          type="radio"
                          name="question_sets"
                          @change="changeQuestionSet($event)"
                        >
                        <span class="radio__text">
                          <plain-text-view
                            :markdown-text="question_set.title"
                            :prefix="question_set.prefix"
                          ></plain-text-view>
                        </span>
                      </label>
                    </li>
                  </ul>
                </div>
            </li>
            <!-- 小問 -->
            <li class="p-learning-select__list__item">
              <div class="subList__wrapper">
                <ul
                  v-if="questions"
                  class="subList on"
                >
                  <li
                    v-for="question in questions"
                    :key="question.id"
                    class="subList__item"
                  >
                    <label class="radio">
                      <input
                        v-model="questionId"
                        :value="question.id"
                        :id="`question-${question.id}`"
                        type="radio"
                        name="questions"
                        @change="changeQuestion($event)"
                      >
                      <span class="radio__text">
                        <plain-text-view
                          :markdown-text="question.text"
                          :prefix="question.prefix"
                        ></plain-text-view>
                      </span>
                    </label>
                  </li>
                </ul>
              </div>
            </li>
          </ul>

          <div class="p-learning-select__caution">
            <div class="c-parts-alert-message -small -icon-top">
              <p>
                検索結果が表示されるまで時間がかかる場合があります。<br>
                ※学習履歴の量や検索条件によって変わります。
              </p>
            </div>
          </div>

          <div class="p-learning-select__footer">
            <ul class="btnList">
              <li class="btnList__item btnList__item--reset">
                <button
                  type="button"
                  name="reselect"
                  class="c-button-white -normal"
                  @click="resetWorkSelectsAndProgressLists"
                >
                  <span class="label">選び直す</span>
                </button>
              </li>
              <li class="btnList__item btnList__item--search">
                <!-- 検索するボタン (活性) -->
                <button
                  v-if="searchable"
                  type="button"
                  name="search"
                  class="c-button-blue -normal"
                  @click="searchLearningProgress"
                ><span class="label">検索する</span>
                </button>
                <!-- 検索するボタン (非活性) -->
                <button
                  v-else
                  type="button"
                  name="search"
                  class="c-button-white -normal -disabled"
                ><span class="label">検索する</span>
                </button>
              </li>
            </ul>
          </div>
          <template v-if="questionCorrectAnswerLists">
            <question-correct-answer-list
              :work-id="workId"
              :title="chapterSectionQuestionSetQuestionTitle"
              :prefix="chapterSectionQuestionSetQuestionPrefix"
              :progress-status="questionCorrectAnswerLists"
              :subject-field="subjectField"
            ></question-correct-answer-list>
          </template>
          <template v-if="chapterSectionQuestionSetList">
            <chapter-section-questionset-list
              :title="chapterSectionQuestionSetQuestionTitle"
              :prefix="chapterSectionQuestionSetQuestionPrefix"
              :progress-status="chapterSectionQuestionSetList"
            ></chapter-section-questionset-list>
          </template>
        </div>
      </section>
    </div>
    <error-modal></error-modal>
  </main>
</template>

<script setup lang="ts">
  import {ref, onMounted, computed} from "vue";
  import { SUBJECTS, SUBJECT_ID_MAP, SUBJECTFIELD_ID_MAP } from "@/consts/subject";
  import { useErrorStore } from "@/store/teacher/error_store";
  import { useLearningProgressStore } from "@/store/teacher/learning_progress_store";
  import { useWorkStore } from "@/store/teacher/work_store";

  // SUBJECTS を元にした 教科名 → 教科識別子 のマップ (e.g. {"理科": "rika"})
  const subjectNameToValue: Record<string, string> = Object.fromEntries(SUBJECTS.map(s => [s.name, s.value]))

  const errorStore = useErrorStore()
  const learningProgressStore = useLearningProgressStore()
  const workStore = useWorkStore()

  const refProgressSelectsList = ref(null)

  // FIXME: NFR-2404 開発: 【T9 学習進捗表】document.title の動的更新処理を実装する
  const academicYearsClassrooms = ref(null);
  const academicSessionId = ref<number | string>('');
  const academicYear = ref<number | string>('');
  const classroom = ref("");
  // 選択中の教科識別子 (e.g. "kokugo")
  const subject = ref("");

  const works = ref<Array<any>>([]);
  // 選択中の教材id: 直接的にはAPIリクエストに使わないが subject_fieldの算出に必須
  const workId = ref<number|null>(null);
  // 選択中の親項目id: APIリクエストに使わない
  const partId = ref<number|null>(null);
  const chapterId = ref<number|null>(null);
  const sectionId = ref<number|null>(null);
  const questionSetId = ref<number|null>(null);
  const questionId = ref<number|null>(null);

  // 検索中か否かの状態を保持するプロパティ（true: 検索中、false: 非検索中）
  // 検索するボタンを検索中に無効化する制御に利用
  const isSearching = ref(false);
  const needsReSelect = ref(false);

  const chapterSectionQuestionSetQuestionTitle = ref("")
  const chapterSectionQuestionSetQuestionPrefix = ref("")
  const chapterSectionQuestionSetList = ref(null)
  const questionCorrectAnswerLists = ref(null)

  // 学年一覧
  const academicYearsBelongCurrentAcademicSessionId = computed(() => {
    if (academicYearsClassrooms.value && academicSessionId.value) {
      return academicYearsClassrooms.value.academicYears[academicSessionId.value] || [];
    }
    return [];
  })

  // 学級一覧
  const classroomsBelongCurrentAcademicYear = computed(() => {
    if (academicYearsClassrooms.value && academicSessionId.value && academicYear.value) {
        return academicYearsClassrooms.value.classrooms[academicSessionId.value][academicYear.value] || [];
    }
    return [];
  })

  // 教科一覧
  const subjects = computed(() => {
    // 学級未選択・未指定時は空リストを返す
    if (!classroom.value) return []
    return workStore.availableWorksBySubject(academicSessionId.value as number, academicYear.value as number) ?? []
  })

  // 選択中の work の教科分野ID
  // 小問正誤リスト、子項目・孫項目・出題単位進捗リストAPIのリクエストパラメーター、および subjectField の算出に使用
  const subjectFieldId = computed((): number | null =>
    works.value.find(w => w.id === workId.value)?.subject_field_id ?? null
  )
  // 選択中の work の教科分野識別子 (e.g. "rika")
  // 小問正誤リスト > 生徒解答 (StudentAnswerView) に渡すためだけに使用
  const subjectField = computed((): string =>
    Object.entries(SUBJECTFIELD_ID_MAP).find(([, id]) => id === subjectFieldId.value)?.[0] ?? ''
  )

  // 親項目一覧
  const parts = computed(() => {
    return (works.value && workId.value ? works.value.find(work => work["id"] == workId.value)?.parts : null)
  })

  // タイトルが設定された親項目が1件以上あるか（親項目セレクタの表示要否に使う）
  const hasTitledParts = computed(() => {
    return !!parts.value?.some(part => part.title.trim().length > 0)
  })

  // 子項目一覧
  const chapters = computed(() => {
    return (parts.value && partId.value ? parts.value.find(part => part["id"] == partId.value)?.chapters : null)
  })

  // 孫項目一覧
  const sections = computed(() => {
    return (chapters.value && chapterId.value ? chapters.value.find(chapter => chapter["id"] == chapterId.value)?.sections : null)
  })

  // 出題単位一覧
  const questionSets = computed(() => {
    return (sections.value && sectionId.value ? sections.value.find(section => section["id"] == sectionId.value)?.question_sets : null)
  })

  // 小問一覧
  const questions = computed(() => {
    return (questionSets.value && questionSetId.value ? questionSets.value.find(questionSet => questionSet["id"] == questionSetId.value)?.questions : null)
  })

  // 検索するボタン押下可
  const searchable = computed(() => {
    return chapterId.value && !isSearching.value && !needsReSelect.value
  })

  onMounted(() => {
    // Data プロパティにクエリパラメーターをセット
    setInitialDataFromSearchParams();
    // クエリパラメーターに応じた初期表示データを取得
    searchInitialDataFromSearchParams();
  })

  function setInitialDataFromSearchParams() {
    // クエリパラメーターから初期値を設定
    // URLのクエリストリングと同期して、上位項目がなければ以降の項目はセットしない
    // cf. https://developer.mozilla.org/ja/docs/Web/API/URL/searchParams
    const params = (new URL(location.toString())).searchParams

    if (params.has("academic_session_id")) {
      const parsed = parseInt(params.get("academic_session_id"), 10);
      academicSessionId.value = !isNaN(parsed) ? parsed : '';
    }
    if (!academicSessionId.value) return

    if (params.has("academic_year")) {
      const parsed = parseInt(params.get("academic_year"), 10);
      academicYear.value = !isNaN(parsed) ? parsed : '';
    }
    if (!academicYear.value) return

    if (params.has("classroom")) {
      const found = params.get("classroom");
      classroom.value = found ? params.get("classroom") : '';
    }
    if (!classroom.value) return

    if (params.has("subject")) {
      const found = SUBJECTS.find(s => s.value === params.get("subject"));
      subject.value = found ? params.get("subject") : "";
    }
    if (!subject.value) return

    if (params.has("work_id")) {
      const parsed = parseInt(params.get("work_id"), 10);
      workId.value = !isNaN(parsed) ? parsed : null;
    }
    if (!workId.value) return

    if (params.has("part_id")) {
      const parsed = parseInt(params.get("part_id"), 10);
      partId.value = !isNaN(parsed) ? parsed : null;
    }
    if (!partId.value) return

    if (params.has("chapter_id")) {
      const parsed = parseInt(params.get("chapter_id"), 10);
      chapterId.value = !isNaN(parsed) ? parsed : null;
    }
    if (!chapterId.value) return

    if (params.has("section_id")) {
      const parsed = parseInt(params.get("section_id"), 10);
      sectionId.value = !isNaN(parsed) ? parsed : null;
    }
    if (!sectionId.value) return

    if (params.has("question_set_id")) {
      const parsed = parseInt(params.get("question_set_id"), 10);
      questionSetId.value = !isNaN(parsed) ? parsed : null;
    }
    if (!questionSetId.value) return

    if (params.has("question_id")) {
      const parsed = parseInt(params.get("question_id"), 10);
      questionId.value = !isNaN(parsed) ? parsed : null;
    }
  }

  // クエリパラメーターに応じた初期表示データを取得
  async function searchInitialDataFromSearchParams() {
    // 学年・学級一覧を取得
    academicYearsClassrooms.value = await learningProgressStore.fetchYearClass();
    // 年度IDに指定がなければ（リクエストに年度ID指定がなければ）年度IDの初期値（当年度）を設定
    academicSessionId.value = academicSessionId.value ?? academicYearsClassrooms.value.defaultAcademicSessionId;

    if (classroom.value) {
      // 選択状態にする教科の有無、選択状態にする教科が決まるまで、
      // 教材検索条件API を呼び出せないので await
      await availableSubjects()
    }
    if (subject.value) {
      // 進捗表・正誤表タイトル・教科分野idは、教材検索条件API の取得結果 (教材一覧) から取得するため、
      // 取得完了するまで await
      await learningProgressWorksConditions()
    }
    if (workId.value) {
      // 表示できる親項目がない場合は自動選択する
      autoSelectPart()
    }
    if (chapterId.value) {
      fetchLearningProgressList()
    }
    replaceHistory()
  }

  function getQueryString(queryParams) {
    // 渡されたクエリパラメータ用データをクエリ文字列化する
    return Object.entries(queryParams)
      .map(queryParam => `${queryParam[0]}=${queryParam[1]}`)
      .join("&");
  }

  function getLearningProgressQueryParams() {
    const params = {}

    // 上位項目がなければ、以降の項目はセットしない
    // （定義の順番に意味があるので変更する場合は注意）
    if (!academicSessionId.value) return params
    params["academic_session_id"] = academicSessionId.value

    if (!academicYear.value) return params
    params["academic_year"] = academicYear.value

    if (!classroom.value) return params
    params["classroom"] = classroom.value

    if (!subject.value) return params
    params["subject"] = subject.value

    if (!workId.value) return params
    params["work_id"] = workId.value

    if (!partId.value) return params
    params["part_id"] = partId.value

    if (!chapterId.value) return params
    params["chapter_id"] = chapterId.value

    if (!sectionId.value) return params
    params["section_id"] = sectionId.value

    if (!questionSetId.value) return params
    params["question_set_id"] = questionSetId.value

    if (!questionId.value) return params
    params["question_id"] = questionId.value

    return params
  }

  function replaceHistory() {
    history.replaceState(
      getLearningProgressQueryParams(),
      "",
      `?${getQueryString(getLearningProgressQueryParams())}`
    )
  }

  /*
    ログイン中の先生の担当教科と、選択中の学級 (年度・学年) の有効な教材ライセンスの存在有無から、
    教科タブを選択状態にする教科を返す
    cf. https://beproud.tracery.jp/projects/meijitosho/pages/3099#toc-3
  */
  function getSubjectToBeSelected() {
    const subjectsHasLicense = subjects.value.filter(s => s.has_license === true)

    // ライセンスがある教科が1つもない → 教科ボタンを非活性にする
    if (subjectsHasLicense.length < 1) {
      return ""
    }

    // 既に選択中の教科にライセンスがある → そのまま維持
    if (subject.value && subjectsHasLicense.find(s => subjectNameToValue[s.name] === subject.value)) {
      return subject.value
    }

    // 担当教科にライセンスがある → 担当教科を選択
    const defaultSubject = subjectsHasLicense.find(s => s.is_default)
    if (defaultSubject) {
      return subjectNameToValue[defaultSubject.name]
    }

    // それ以外 → ライセンスがある先頭の教科を選択
    return subjectNameToValue[subjectsHasLicense[0].name]
  }

  // 親項目自動選択
  function autoSelectPart() {
    if (hasTitledParts.value) {
      return
    }
    // 表示できる親項目がない場合は裏で先頭の親項目を選択する
    partId.value = parts.value[0].id
  }

  // 教材選択ボックススライド
  function slideWorkSelects(event) {
    const basePosition = refProgressSelectsList.value.getBoundingClientRect().left
    const baseWidth = refProgressSelectsList.value.getBoundingClientRect().width

    const progressSelectsListItem = event.currentTarget.closest(".p-learning-select__list__item")
    const itemRightPosition = progressSelectsListItem.getBoundingClientRect().right
    const itemMargin = parseFloat(window.getComputedStyle(progressSelectsListItem).getPropertyValue("margin-left")) || 0
    const itemWidth = progressSelectsListItem.getBoundingClientRect().width

    if( (baseWidth / 2) <= (itemRightPosition + itemMargin - basePosition) ){
      refProgressSelectsList.value.scrollLeft = refProgressSelectsList.value.scrollLeft + itemWidth + itemMargin
    }
  }

  // 表示する学習進捗表・小問正誤表のタイトルとプレフィックスを返す
  function getCurrentChapterSectionQuestionSetQuestionTitle() {
    const emptyStr = ""  // 条件に合致するタイトル、プレフィックスが存在しない場合は空文字を返す
    let selected = null

    // FIXME: changeChapter/changeSection/changeQuestionSet は下位項目をリセットするため
    // 「下位項目があれば上位項目も必ず存在する」が保証されている。
    // そのため各分岐の上位条件（chapterId.value, sectionId.value など）は重複しており省略可能。
    // 例: `if (questionId.value)` / `else if (questionSetId.value)` / ... のように簡略化できる。
    if (chapterId.value && sectionId.value && questionSetId.value && questionId.value) {
      // 小問タイトルを返すケース
      selected = questions.value.find(question => question.id === questionId.value)
      return selected ? [selected.text, selected.prefix] : [emptyStr, emptyStr]
    }

    if (chapterId.value && sectionId.value && questionSetId.value) {
      // 出題単位タイトルを返すケース
      selected = questionSets.value.find(questionSet => questionSet.id === questionSetId.value)
    } else if (chapterId.value && sectionId.value) {
      // 孫項目タイトルを返すケース
      selected = sections.value.find(section => section.id === sectionId.value)
    } else if (chapterId.value) {
      // 子項目タイトルを返すケース
      selected = chapters.value.find(chapter => chapter.id === chapterId.value)
    }

    return selected ? [selected.title, selected.prefix] : [emptyStr, emptyStr]
  }

  // 年度セレクトボックス操作時
  function changeAcademicSessionId() {
    academicYear.value = '';
    classroom.value = "";
    subject.value = "";
    works.value = []
    resetWorkSelectsAndProgressLists()
  }

  // 学年セレクトボックス操作時
  function changeAcademicYear() {
    classroom.value = "";
    subject.value = "";
    works.value = []
    resetWorkSelectsAndProgressLists()
  }

  // 学級セレクトボックス変更時
  async function changeClassroom() {
    subject.value = "";
    works.value = []
    resetWorkSelectsAndProgressLists()

    await availableSubjects()

    if (subject.value) {
      learningProgressWorksConditions()
    }
    replaceHistory();
  }

  // 教科選択時
  function clickSubject(subjectValue) {
    subject.value = subjectValue
    works.value = []
    resetWorkSelectsAndProgressLists()

    learningProgressWorksConditions()
    replaceHistory()
  }

  // 教材選択時
  function changeWork(event) {
    partId.value = chapterId.value = sectionId.value = questionSetId.value = questionId.value = null

    autoSelectPart()
    slideWorkSelects(event)
  }

  // 親項目選択時
  function changePart(event) {
    chapterId.value = sectionId.value = questionSetId.value = questionId.value = null

    slideWorkSelects(event)
  }

  // 子項目選択時
  function changeChapter(event) {
    sectionId.value = questionSetId.value = questionId.value = null;

    releaseNeedsReSelect()
    slideWorkSelects(event)
  }

  // 孫項目選択時
  function changeSection(event) {
    questionSetId.value = questionId.value = null;

    releaseNeedsReSelect()
    slideWorkSelects(event)
  }

  // 出題単位選択時
  function changeQuestionSet(event) {
    questionId.value = null;

    releaseNeedsReSelect()
    slideWorkSelects(event)
  }

  // 小問選択時
  function changeQuestion(event) {
    releaseNeedsReSelect()
    slideWorkSelects(event)
  }

  // 教材選択ボックス以下をリセットする
  function resetWorkSelectsAndProgressLists() {
    workId.value = partId.value = chapterId.value = sectionId.value = questionSetId.value = questionId.value = null
    chapterSectionQuestionSetList.value = null
    questionCorrectAnswerLists.value = null

    refProgressSelectsList.value.scrollLeft = 0
  }

  // 検索ボタン押下時
  function searchLearningProgress() {
    // 検索実行で検索中ステータスを true に更新
    isSearching.value = true
    fetchLearningProgressList().then(() => {
      // APIレスポンスが返ってきたら検索中ステータスを false に更新
      isSearching.value = false
    })
    replaceHistory()
  }

  // 教材項目選択し直しステータス解放
  function releaseNeedsReSelect() {
    if (!isSearching.value && needsReSelect.value) {
      needsReSelect.value = false
    }
  }

  // 教科一覧取得
  async function availableSubjects() {
    await workStore.fetchAvailableWorksBySubject({
      academic_session_id: academicSessionId.value as number,
      academic_year: academicYear.value as number,
    })
    subject.value = getSubjectToBeSelected()
  }

  // 教材検索条件取得
  async function learningProgressWorksConditions() {
    works.value = await learningProgressStore.fetchLearningProgressWorksConditions(
      {
        "classroom_uuid": classroom.value,
        "subject_id": SUBJECT_ID_MAP[subject.value]
      }
    )
  }

  // 学習進捗表, 小問正誤表取得
  async function fetchLearningProgressList() {
    // 当関数が呼び出されるタイミングでは必ずworkは選択済み。選択したworkが存在しない場合は不正操作とみなし考慮しない。
    if (questionId.value) {
      // 小問正誤リスト取得
      questionCorrectAnswerLists.value = await learningProgressStore.fetchLearningProgressQuestionCorrectAnswerList(
        {
          classroom_uuid: classroom.value,
          subject_field_id: subjectFieldId.value,
          question_id: questionId.value,
        }
      )
      chapterSectionQuestionSetList.value = null
    } else {
      // 子項目・孫項目・出題単位進捗リスト取得
      chapterSectionQuestionSetList.value = await learningProgressStore.fetchLearningProgressChapterSectionQuestionSetList(
        {
          classroom_uuid: classroom.value,
          subject_field_id: subjectFieldId.value,
          chapter_id: chapterId.value,
          section_id: sectionId.value,
          question_set_id: questionSetId.value,
        }
      )
      if (errorStore.getTeacherError && errorStore.getTeacherError.code === "E003") {
        // DBタイムアウトエラーの場合は、項目を選択し直すまで[検索する]ボタン非活性
        needsReSelect.value = true
      }
      questionCorrectAnswerLists.value = null
    }

    [
      chapterSectionQuestionSetQuestionTitle.value,
      chapterSectionQuestionSetQuestionPrefix.value
    ] = getCurrentChapterSectionQuestionSetQuestionTitle()
  }
</script>

<style lang="scss" scoped>
</style>
